export default {
	'展位基本信息':'Basic information of booth',
	'展位面积(m²)':'Booth area(m²)',
	'请输入展位面积':'Please enter booth area',
	'展台尺寸（长x宽）':'Exhibition stand size (long x wide)',
	'请输入展台尺寸':'Please enter booth size',
	'最高的至地面垂直高度(m)':'The highest vertical height to the ground(m)',
	'请输入最高的至地面垂直高度':'Please enter the highest vertical height to the ground.',
	'顶部结构覆盖面积(m²)':'Coverage area of top structure(m²)',
	'请输入顶部结构覆盖面积':'Please enter the coverage area of the top structure.',
	'横跨结构最大尺寸(m)':'Maximum size of span structure(m)',
	'请输入横跨结构最大尺寸':'Please enter the maximum size of the span structure.',
	'展位用电总功率(kw)':'Total power consumption for booths(kw)',
	'请输入展位用电总功率':'Please input the total power of the booth.',
	'承重墙体最小厚度(cm)':'Minimum Thickness of Bearing Wall(cm)',
	'请输入承重墙体最小厚度':'Please enter the minimum thickness of load-bearing wall',
	'用电线路规格(m²)':'Specification of Electric Circuit(mm²)',
	'请输入用电线路规格':'Please enter the specifications of power lines',
	'上一步':'Previous',
	'下一步':'Save&Next',
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsBoothInfo.js